import {ARRANGEMENT_VIEW, MIX_VIEW} from 'constants/view-modes.js';
import {PIANO_ROLL, WAVEFORM} from 'constants/arrangement-modes.js';
import {AUDITION_NEXT_SAMPLE, AUDITION_PREVIOUS_SAMPLE} from "constants/event-types";
import {
    TRACKER_PARAMETERS,
    mixArrowLeft,
    mixArrowRight,
    mixArrowUp,
    mixArrowDown
} from 'components/mix/mix2/trackerUtils.js';
import {
    arrangementBackspace,
    arrangementArrowLeft,
    arrangementArrowRight,
} from 'components/arrangement/key.js';

export default superclass => class extends superclass {
    onArrowDown(e) {
        e.preventDefault();
        if (this.sampleExplorerSelected) {
            this.selectedTrack.auditionNext();
            return;
        }
        if (this.isShowingSoundsPane(false)) {
            let num = e.ctrlKey || e.metaKey ? 10 : 1;
            if (this.showingSoundList) {
                if (this.currentSoundInList === undefined) {
                    this.currentSoundInList = 0;
                } else {
                    this.currentSoundInList += num;
                }
            } else {
                // we are in tags view then
                if (this.currentTagInList === undefined) {
                    this.currentTagInList = 0;
                } else {
                    this.currentTagInList += num;
                }
            }
            return;
        }

        if (this.viewMode === MIX_VIEW && this.currentScene) {
            let index = this.scenes.indexOf(this.currentScene);
            let scene = this.scenes[(index + 1) % this.scenes.length];
            this.sequencerEngine.scenes.switchToScene(scene);
            return;
        }

        if (this.showSamples2D && this.isShowingSoundsPane()) {
            return;
        }
        /*
        if (this.viewMode === MIX_VIEW) {
            // this.sequencerEngine.switchToNextPattern();
            mixArrowDown(this.sequencerEngine);
            return;
        }
        */

        if (this.sampleAuditioning) {
            window.dispatchEvent(new Event(AUDITION_NEXT_SAMPLE));
        } else {
            let selectedSteps = this.getSelectedSteps();
            if (selectedSteps && selectedSteps.length > 0) {
                this.moveSteps(selectedSteps, 0, e.ctrlKey || e.metaKey ? -12 : -1);
            } else {
                var numTracks = this.sequencerEngine.tracks.length;
                this.sequencerEngine.down();
                this.onSelectTrack(this.cursor.track);
            }
        }
        return true;
    }

    onArrowRight(e) {
        if (this.isShowingSoundsPane(false)) {
            let num = e.ctrlKey || e.metaKey ? 10 : 1;
            if (!this.showingSoundList) {
                // we are in tags view then
                if (this.currentTagInList === undefined) {
                    this.currentTagInList = 0;
                } else {
                    this.currentTagInList += num;
                }
            }
            return;
        }

        if (this.waveformShowing) {
            return;
        }

        e.preventDefault();

        if (this.showSamples2D && this.isShowingSoundsPane()) {
            return;
        }

        if (this.viewMode === ARRANGEMENT_VIEW) {
            return arrangementArrowRight(this.sequencerEngine);
        }

        /*
        if (this.viewMode === MIX_VIEW) {
            mixArrowRight(this.sequencerEngine);
            return;
        }
        */

        if (this.cursor.track in this.sequencerEngine.tracks) {
            let selectedSteps = this.getSelectedSteps();
            if (selectedSteps && selectedSteps.length > 0) {
                this.moveSteps(selectedSteps, e.ctrlKey || e.metaKey ? 4 : 1, 0);
            } else {
                this.sequencerEngine.right();
            }
        }
    };

    onArrowLeft(e) {
        if (this.isShowingSoundsPane(false)) {
            let num = e.ctrlKey || e.metaKey ? 10 : 1;
            if (!this.showingSoundList) {
                // we are in tags view then
                if (this.currentTagInList === undefined) {
                    this.currentTagInList = 0;
                } else {
                    this.currentTagInList = Math.max(0, this.currentTagInList - num);
                }
            }
            return;
        }

        if (this.waveformShowing) {
            return;
        }

        e.preventDefault();
        if (this.showSamples2D && this.isShowingSoundsPane()) {
            return;
        }

        if (this.viewMode === ARRANGEMENT_VIEW) {
            return arrangementArrowLeft(this.sequencerEngine);
        }

        /*
        if (this.viewMode === MIX_VIEW) {
            // this.sequencerEngine.switchToPreviousSubSequence();
            mixArrowLeft(this.sequencerEngine);
            return;
        }
        */

        let selectedSteps = this.getSelectedSteps();
        if (selectedSteps && selectedSteps.length > 0) {
            this.moveSteps(selectedSteps, e.ctrlKey || e.metaKey ? -4 : -1, 0);
        } else {
            this.sequencerEngine.left();
        }
    }

    onArrowUp(e) {
        e.preventDefault();
        if (this.sampleExplorerSelected) {
            this.selectedTrack.auditionPrevious();
            return;
        }
        if (this.isShowingSoundsPane(false)) {
            let num = e.ctrlKey || e.metaKey ? 10 : 1;
            if (this.showingSoundList) {
                if (this.currentSoundInList === undefined) {
                    this.currentSoundInList = 0;
                } else {
                    this.currentSoundInList = Math.max(0, this.currentSoundInList - num);
                }
            } else {
                // we are in tags view then
                if (this.currentTagInList === undefined) {
                    this.currentTagInList = 0;
                } else {
                    this.currentTagInList = Math.max(0, this.currentTagInList - num);
                }
            }
            return;
        }

        if (this.viewMode === MIX_VIEW && this.currentScene) {
            let index = this.scenes.indexOf(this.currentScene) - 1;
            let scene = this.scenes[index < 0 ? this.scenes.length - 1 : index];
            this.sequencerEngine.scenes.switchToScene(scene);
            return;
        }

        if (this.showSamples2D && this.isShowingSoundsPane()) {
            return;
        }
        /*
        if (this.viewMode === MIX_VIEW) {
            // this.sequencerEngine.switchToPreviousPattern();
            mixArrowUp(this.sequencerEngine);
            return;
        }
        */

        if (this.sampleAuditioning) {
            window.dispatchEvent(new Event(AUDITION_PREVIOUS_SAMPLE));
        } else {
            let selectedSteps = this.getSelectedSteps();
            if (selectedSteps && selectedSteps.length > 0) {
                this.moveSteps(selectedSteps, 0, e.ctrlKey || e.metaKey ? 12 : 1);
            } else {
                this.sequencerEngine.up();
                this.onSelectTrack(this.cursor.track);
            }
        }
        return true;
    };
}
